import React from 'react';
import { ImageQualityGate } from './ImageQualityGate';
import ImageQualityReport from './ImageQualityReport';

/** The Evidence Image Quality page (route /image-quality), behind the image-quality gate. */
const ImageQualityGated: React.FC = () => (
  <ImageQualityGate pageName="Evidence Image Quality" testIdPrefix="image-quality">
    <ImageQualityReport />
  </ImageQualityGate>
);

export default ImageQualityGated;
